import InfiniteScroll from "react-infinite-scroller";
import {Trans} from "@lingui/macro";
import {Divider} from "antd";
import ListGroup from "./ListGroup";
import Empty from "./Empty";
import TopbarNotificationStyled from "./style";
import React, {memo, useCallback, useMemo} from "react";
import dayjs from 'dayjs';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import NotificationActions from "../../redux/Notification/actions";
import {CloseOutlined} from "@ant-design/icons";

const {
    readNotification,
    closeDropdown,
} = NotificationActions;

function NotificationDropdown() {
    const items = useSelector(state => state.Notification.items, shallowEqual);
    const lastId = useSelector(state => state.Notification.lastId);
    const hasMore = useSelector(state => state.Notification.hasMore);

    const dispatch = useDispatch();

    const handleInfiniteOnLoad = useCallback(() => {
        dispatch(readNotification(lastId));
    }, [dispatch, lastId]);

    const [todayItems, olderItems] = useMemo(() => {
        const todayItems = [];
        const olderItems = [];
        items.forEach(data => {
            // const duration = Moment.duration(dayjs().diff(data.created_at));
            // const hours = duration.asHours();
            const hourDuration = dayjs().diff(data.created_at, 'hour');
            if (hourDuration < 24)
                todayItems.push(data);
            else
                olderItems.push(data);
        });
        return [todayItems, olderItems];
    }, [items]);

    return (
        <TopbarNotificationStyled
            className="notification-popover"
        >
            <button
                type="button"
                aria-label="Close"
                className="ant-modal-close"
                onClick={() => dispatch(closeDropdown())}
            >
                <span className="popover-close-button ant-modal-close-x">
                    <CloseOutlined />
                </span>
            </button>
            <InfiniteScroll
                initialLoad={false}
                pageStart={0}
                loadMore={handleInfiniteOnLoad}
                hasMore={hasMore}
                useWindow={false}
            >
                <div className="heading-row">
                    <Trans>Notifications</Trans>
                </div>
                <Divider className="divider" />
                <div className="content-container">
                    <ListGroup type="Today" items={todayItems} />
                    <ListGroup type="Older" items={olderItems} />
                    {!todayItems.length && !olderItems.length ? <Empty /> : null}
                </div>
            </InfiniteScroll>
        </TopbarNotificationStyled>
    );
}

export default memo(NotificationDropdown);
